"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResumePositionTracker = void 0;
var StorageUtils_1 = require("./StorageUtils");
var DummyComponent_1 = require("../components/DummyComponent");
var STORAGE_KEY_PREFIX = "".concat((0, DummyComponent_1.prefixCss)('resume'), ".");
var MIN_RESUME_POSITION = 5;
/**
 * Watches player events and stores the last known playback position for the active source.
 *
 * @category Utils
 */
var ResumePositionTracker = /** @class */ (function () {
    function ResumePositionTracker(player) {
        var _this = this;
        this.player = player;
        this.activeSourceKey = null;
        this.lastPosition = null;
        this.updatePosition = function (event) {
            var _a, _b;
            if (((_b = (_a = _this.player.ads) === null || _a === void 0 ? void 0 : _a.isLinearAdActive) === null || _b === void 0 ? void 0 : _b.call(_a)) === true)
                return;
            if (isFinite(event.time)) {
                _this.lastPosition = event.time;
            }
        };
        this.savePosition = function (time) {
            if (!_this.activeSourceKey)
                return;
            if (time === null)
                return;
            if (!isFinite(time) || time < MIN_RESUME_POSITION) {
                StorageUtils_1.StorageUtils.removeItem(_this.activeSourceKey);
                return;
            }
            StorageUtils_1.StorageUtils.setItem(_this.activeSourceKey, String(time));
        };
        this.pausePositionTracking = function () {
            var _a, _b;
            if (((_b = (_a = _this.player.ads) === null || _a === void 0 ? void 0 : _a.isLinearAdActive) === null || _b === void 0 ? void 0 : _b.call(_a)) === true)
                return;
            var time = _this.player.getCurrentTime();
            if (isFinite(time)) {
                _this.lastPosition = time;
            }
            _this.savePosition(_this.lastPosition);
        };
        this.storeCurrentPosition = function () {
            _this.savePosition(_this.lastPosition);
        };
        this.storeCurrentPositionWhenHidden = function () {
            if (document.visibilityState === 'hidden') {
                _this.storeCurrentPosition();
            }
        };
        this.startPositionTracking = function () {
            _this.stopPositionTracking();
            _this.activeSourceKey = null;
            _this.lastPosition = null;
            if (_this.player.isLive())
                return;
            var activeSourceKey = storageKeyFor(_this.player.getSource());
            if (!activeSourceKey)
                return;
            _this.activeSourceKey = activeSourceKey;
            _this.player.on(_this.player.exports.PlayerEvent.TimeChanged, _this.updatePosition);
            _this.player.on(_this.player.exports.PlayerEvent.Paused, _this.pausePositionTracking);
            _this.player.on(_this.player.exports.PlayerEvent.PlaybackFinished, _this.finishPositionTracking);
            document.addEventListener('visibilitychange', _this.storeCurrentPositionWhenHidden);
        };
        this.restartPositionTracking = function () {
            if (!_this.activeSourceKey && _this.player.getSource() !== null) {
                _this.startPositionTracking();
            }
        };
        this.unloadSource = function () {
            _this.savePosition(_this.lastPosition);
            _this.stopPositionTracking();
            _this.activeSourceKey = null;
            _this.lastPosition = null;
        };
        this.finishPositionTracking = function () {
            if (_this.activeSourceKey) {
                StorageUtils_1.StorageUtils.removeItem(_this.activeSourceKey);
            }
            _this.stopPositionTracking();
            _this.activeSourceKey = null;
            _this.lastPosition = null;
        };
        player.on(player.exports.PlayerEvent.SourceLoaded, this.startPositionTracking);
        player.on(player.exports.PlayerEvent.SourceUnloaded, this.unloadSource);
        player.on(player.exports.PlayerEvent.Play, this.restartPositionTracking);
        if (player.getSource() !== null)
            this.startPositionTracking();
    }
    ResumePositionTracker.prototype.release = function () {
        this.storeCurrentPosition();
        document.removeEventListener('visibilitychange', this.storeCurrentPositionWhenHidden);
        this.activeSourceKey = null;
        this.lastPosition = null;
    };
    ResumePositionTracker.prototype.getStoredPosition = function () {
        if (this.player.isLive())
            return null;
        var activeSourceKey = storageKeyFor(this.player.getSource());
        if (!activeSourceKey)
            return null;
        var time = Number(StorageUtils_1.StorageUtils.getItem(activeSourceKey));
        return isFinite(time) && time >= MIN_RESUME_POSITION ? time : null;
    };
    ResumePositionTracker.prototype.stopPositionTracking = function () {
        this.player.off(this.player.exports.PlayerEvent.TimeChanged, this.updatePosition);
        this.player.off(this.player.exports.PlayerEvent.Paused, this.pausePositionTracking);
        this.player.off(this.player.exports.PlayerEvent.PlaybackFinished, this.finishPositionTracking);
        document.removeEventListener('visibilitychange', this.storeCurrentPositionWhenHidden);
    };
    return ResumePositionTracker;
}());
exports.ResumePositionTracker = ResumePositionTracker;
function storageKeyFor(source) {
    var id = sourceIdentifier(source);
    return id ? STORAGE_KEY_PREFIX + hashSourceIdentifier(id) : null;
}
function sourceIdentifier(source) {
    var _a;
    if (!source)
        return null;
    if (source.title)
        return 'title:' + source.title;
    if (source.dash)
        return 'dash:' + source.dash;
    if (source.hls)
        return 'hls:' + source.hls;
    if (source.smooth)
        return 'smooth:' + source.smooth;
    if (typeof source.progressive === 'string')
        return 'progressive:' + source.progressive;
    if (Array.isArray(source.progressive) && ((_a = source.progressive[0]) === null || _a === void 0 ? void 0 : _a.url)) {
        return 'progressive:' + source.progressive[0].url;
    }
    return null;
}
function hashSourceIdentifier(sourceIdentifier) {
    var hash = 0;
    for (var i = 0; i < sourceIdentifier.length; i++) {
        hash = (hash << 5) - hash + sourceIdentifier.charCodeAt(i);
        hash |= 0;
    }
    return (hash >>> 0).toString(36);
}
